// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://pupflkhgreielehxetyu.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB1cGZsa2hncmVpZWxlaHhldHl1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTgzMDIyNjIsImV4cCI6MjA3Mzg3ODI2Mn0.5gLUO2k-IOvJ1iJ1KXy3ixjnI3JDxV96E1cuwx3aj2Q";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});